import React from "react";
import useTranslationAdmin from "../useTranslationAdmin";
import useShowLoader from "../../common/loading-widgets/useShowLoader";
import PageSubtitle from "../../common/widgets/PageSubtitle";
import "./JobCountItem.scss";
import JobStatusEnum, {getJobStatusLabel} from "../../jobs/JobStatusEnum";
import useTranslationJobs from "../../jobs/useTranslationJobs";
import JobStatusCountItem from "./JobStatusCountItem";

export default function JobCountItem(/*props*/) {
  const { t, loading: tLoading } = useTranslationAdmin();
  const {t: jobT, loading: jobTLoading } = useTranslationJobs();

  useShowLoader(tLoading || jobTLoading, "JobCountItem");

  return (
    <div className="JobCountItem">
      <PageSubtitle
        colTitle={t("admin:admin_dashboard_job_count_title")}
      />
      {Object.keys(JobStatusEnum).map(status =>
          <JobStatusCountItem key={status} status={status} statusLabel={getJobStatusLabel(jobT, status)}/>
      )}
    </div>
  );
}
